import { render, staticRenderFns } from "./ClaimStatusLookup.vue?vue&type=template&id=4a5be74f"
import script from "./ClaimStatusLookup.vue?vue&type=script&lang=ts"
export * from "./ClaimStatusLookup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports